import styled from 'styled-components';

export const StyledAchievement = styled.div`
    display: flex;
    flex-direction: row;
    margin: 10px;
    align-items: center;
`;

export const Place = styled.p`
    font-family: BlenderProBold, serif;
    font-size: 20px; 
    position: absolute;
    top: -15px;
    right: 40%;
    color: white;
`;

export const AchievementInfo = styled.p`
    font-family: Caveat, serif;
    font-size: 18px; 
    color: ${({color}) => color};
    margin-left: 25px;
`;

export const AchievementContainer = styled.div`
    width: 50px;
    height: 50px;
    position: relative;
`;
